/**
 * Agent type constants.
 * Currently only SEARCH_AGENT is supported.
 */
export const AGENT_TYPES = { SEARCH_AGENT: 'SEARCH_AGENT' };
//# sourceMappingURL=AgentType.js.map